import * as types from './types';

export const state = {
  list: [],
  active: {},
};

export const mutations = {
  [types.THEME_SET_LIST](state, list) {
    state.list = list;
  },
  [types.THEME_SET_ACTIVE](state, active) {
    state.active = active;
  },
  [types.THEME_RESET_STATE](state) {
    state.list = [];
    state.active = {};
  },
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/theme/mutations.js
 **/